import React from 'react';
import { XGrid, GridColDef, GridSortDirection } from '@material-ui/x-grid';
import { gridStyles } from '../../datagrid.style';
import { SubmitToolbar } from './SubmitToolbar';
import { ModalComponentProps } from '../modal.types';
import { TradeExecutionDisplay } from './TradeExecutionDisplay';

const SubmitScreen = (admin = false) =>
  function (props: ModalComponentProps): JSX.Element {
    const gridClasses = gridStyles();
    const { closeModal, rows, columns } = props;
    const [legData, setLegData] = React.useState<string[]>();
    const [legID, setLegID] = React.useState<number[]>([]);

    const rowValues = Array.from(rows.values());

    // filters columns down to required
    const newColumns = columns.reduce<GridColDef[]>((prev: GridColDef[], curr: GridColDef) => {
      const requiredColumns = ['ID', 'Time', 'Product', 'Volume', 'Price', 'Option', 'hide_SEntity', 'hide_BEntity', 'Buy Account', 'Sell Account', 'Code'];
      return requiredColumns.includes(curr.field) ? [...prev, { ...curr, resizable: false, align: 'center', hide: false }] : prev;
    }, []);

    return legData ? (
      <TradeExecutionDisplay legData={legData} closeModal={closeModal} legID={legID} />
    ) : (
      <XGrid
        columns={newColumns}
        hideFooterPagination={false}
        rows={rowValues}
        autoPageSize
        checkboxSelection
        pagination
        className={gridClasses.modalRoot}
        sortModel={[
          {
            field: 'ID',
            sort: 'desc' as GridSortDirection,
          },
        ]}
        components={{
          Toolbar: SubmitToolbar(closeModal, setLegData, setLegID, admin),
        }}
      />
    );
  };
export { SubmitScreen };
